import React from 'react';
import PropTypes from 'prop-types';
import {Translate} from "app/services/translate";

export const LabelColumn = ({amount}) => (
    <div className="box box-label">
        <div className="value">
            {Translate('commons_exchange')}
        </div>
        <div className="value">
            {Translate('commons_fee')}
        </div>
        <div className="value">
            {Translate('commons_delivery_time')}
        </div>
        <div className="value">
            {`${Translate('commons_you_send')}
              ${amount.toString.replace('.00', '')}`}
        </div>
        <div className="value">
            {Translate('commons_save_profit')}
        </div>
    </div>
);

LabelColumn.propTypes = {
    amount: PropTypes.object,
};
